import axios from 'axios';

export const APIBaseURL =
  window.location.hostname === 'localhost' ? 'https://gucodd.ru' : '/';

export const axiosV0 = axios.create();
axiosV0.defaults.baseURL = APIBaseURL;
